


export const clearState = {
    type: "CLEAR_STATE"
}